<template>
    <div>

        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="image in CarouselAdverts" :key="image.Id">
                <van-image width="100%" fit="contain" :src="image.CompleteFileName" />
            </van-swipe-item>
        </van-swipe>
    </div>
</template>
<script>
import axios from "../commons/AxiosMethod.js"
import tools from "../commons/tools.js"

import { Collapse, CollapseItem, Tab, Tabs, showToast, NumberKeyboard } from "vant"

export default {
  data () {
    return {
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      CarouselAdverts: []
    }
  },
  name: "App",
  mounted () {
    this.GetHomeCarouselAdverts()
  },
  components: {
  },
  methods: {
    GetHomeCarouselAdverts () {
      axios.apiMethod(
        "/shoppings/Advert/GetHomeCarouselAdverts",
        "get",
        {},
        (result) => {
          this.CarouselAdverts = result.Data
        }
      )
    }

  }
}
</script>
<style lang="scss" scoped></style>
